import { useState, useEffect, useCallback } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Charge les totaux de stock consigné consolidés pour tous les destinataires du client.
 * GET /consignment/stock (mode consolidé, sans address_id).
 */
export default function useGetConsignmentStockSummaries(enabled = true) {
  const [summariesByAddressId, setSummariesByAddressId] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!enabled) {
      setSummariesByAddressId({});
      return;
    }

    setIsLoading(true);
    try {
      const response = await fleetApi.get('/consignment/stock');
      const map = {};
      (response.data?.data ?? []).forEach((entry) => {
        map[entry.address_id] = {
          address_id: entry.address_id,
          total_stock: entry.total_stock,
        };
      });
      setSummariesByAddressId(map);
    } catch {
      setSummariesByAddressId({});
    } finally {
      setIsLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getTotalForAddress = useCallback(
    (addressId) => summariesByAddressId[addressId]?.total_stock ?? null,
    [summariesByAddressId]
  );

  return {
    summariesByAddressId,
    isLoading,
    getTotalForAddress,
    mutate: fetchData,
  };
}
